import { brandAndCountryFromZone } from '@seek/audience-zones';
import { getZoneFromSite, getLanguageFromLocale } from '@seek/melways-sites';

import type { CurrentAdvertiserContext } from 'src/graphql/generated';
import { getTrackingCountryCode } from 'src/modules/analyticsTracking/getTrackingCountryCode';
import { trackPageLoad } from 'src/modules/analyticsTracking/trackers';
import { getLocale } from 'src/utils/config';

import { useConfig } from '../modules/ConfigProvider/use-config';

import { useAccountContext } from './use-account-context';

export const useTracking = () => {
  const { data: accountContext } = useAccountContext();
  const { site, isProd, isStaging } = useConfig();

  const zone = getZoneFromSite(site);
  const brandAndCountry = brandAndCountryFromZone(zone);

  const trackView = (
    pageName: string,
    currentPage: string,
    pageData?: Record<string, unknown>,
  ) => {
    const currentAdvertiser = accountContext?.currentAdvertiser as
      | CurrentAdvertiserContext
      | undefined;
    const currentUser = accountContext?.headerFooterContext?.user;
    const hirerUserEmail =
      accountContext?.headerFooterContext?.identityContext?.email;

    if (
      !currentAdvertiser ||
      !currentUser ||
      !hirerUserEmail ||
      (!isProd && !isStaging)
    ) {
      return;
    }

    const [brand, country] = brandAndCountry?.length ? brandAndCountry : [];

    const data = {
      eventName: pageName,
      brand,
      siteCountry: getTrackingCountryCode(country),
      zone,
      siteSection: 'account',
      siteSubsection: 'user management',
      siteLanguage: getLanguageFromLocale(getLocale()),
      currentPage,
      seekAdvertiserId: currentAdvertiser.seekId,
      advertiserAdCentreId: currentAdvertiser.advertiserId,
      userId: currentUser.id,
      hirerUserEmail,
      hirerUserFullName: currentUser.name,
      isLoggedIn: true,
      ...(pageData || {}),
    };
    trackPageLoad(pageName, data);
  };

  return { trackView };
};
